var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.qrCode)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('label',{staticStyle:{"margin-bottom":"5px","white-space":"nowrap"},attrs:{"for":"text"}},[_vm._v(_vm._s(_vm.data.label))]),_c('img',{attrs:{"src":_vm.qrCode,"alt":"QR Code"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }